var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.has_received)?_c('b-button',{staticClass:"m-l-15",attrs:{"size":"sm","variant":"outline-info"},on:{"click":function($event){$event.stopPropagation();return _vm.viewDiff.apply(null, arguments)}}},[_c('i',{staticClass:"icon-eye"}),_vm._v(" Dif ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }